import { Link } from "react-router-dom";
import arrow from "../../images/icons/arrow-right.png";

export default function RouteMap({ items }) {
  return (
    <ul className="routeMap">
      {items.map(({ route, title, image }) => (
        <li className="routeMap__item" key={route}>
          <Link to={route}>
            <div className="routeMap__item--desc">
              <div className="routeMap__item--img">
                <img src={image} alt={title} />
              </div>
              <p className="routeMap__item--text">{title}</p>
            </div>
            <img src={arrow} alt="arrow" />
          </Link>
        </li>
      ))}
    </ul>
  );
}
